<template>
  <div class="image-text">
    <slot name="text"></slot>
    <slot name="image"></slot>
  </div>
</template>

<script>
export default {
  name: "ImageTextLeft",
};
</script>

<style lang="scss" scoped>
.image-text {
  align-items: flex-end;

  @include mobile {
    flex-direction: column-reverse;
  }

  p {
    flex: 1;
  }

  img {
    flex: 3;
  }
}
</style>
